import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationChallengeTotalActivityNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M18.707 4.049l.756 1.119 1.755-1.184-3.838 7.226a2.063 2.063 0 01-1.82 1.095H8.51A3.4 3.4 0 005.5 14.12l-4.29 8.05h1.54l3.94-7.42a2.073 2.073 0 011.82-1.1h7.05a3.415 3.415 0 003.02-1.815l3.745-7.051V6.82h1.35V.7z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationChallengeTotalActivityNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationChallengeTotalActivityNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationChallengeTotalActivityNormalSmall;
